'use client'
import { Teams } from '@glovo/organisation'
import classNames from 'classnames'
import type { FC } from 'react'
import React, { useEffect } from 'react'
import { AddressList } from './address-list/AddressList'
import styles from './WhereToDeliver.module.scss'
import { useLocalisation } from '@/tools/i18n/client'
import { useErrorHandling, withErrorBoundary } from '@/tools/o11y/client'
import { Button, ButtonSize, ButtonVariants } from '@/tools/ui'
import { useAddressBookContext } from '@/user/address-book/AddressBookContext'
import { addressLandingOptionClickedEvent } from '@/user/address-book/analytics'
import { TitleDesktop } from '@/user/address-book/ui/components/title-desktop/TitleDesktop'

export const WhereToDeliverComponent: FC = () => {
  const { execWithErrorTracking } = useErrorHandling()
  const { t } = useLocalisation()
  const { navigate, addressData, resetAddress, setIsInArea, isMobile } = useAddressBookContext()

  const handleCreateNewAddress = () => {
    navigate('onCreateNewAddress')
    addressLandingOptionClickedEvent('NewAddress')
  }

  useEffect(() => {
    execWithErrorTracking(() => {
      if (addressData.latitude || addressData.longitude || addressData.addressLine) {
        setIsInArea(true)
        resetAddress()
      }
    })
  }, [addressData, setIsInArea, resetAddress, execWithErrorTracking])

  return (
    <div className={styles.whereToDeliver}>
      {isMobile ? (
        <h2 className={styles.titleMobile}>{t('address-list.title')}</h2>
      ) : (
        <TitleDesktop title={t('address-list.title')} />
      )}
      <section
        className={classNames({
          [styles.content]: true,
          [styles.contentMobile]: isMobile,
        })}
      >
        <AddressList />
      </section>
      <section className={styles.createButton}>
        <Button
          block
          size={ButtonSize.medium}
          type="button"
          variant={ButtonVariants.secondary}
          onClick={handleCreateNewAddress}
        >
          {t('address-list.add-new-address')}
        </Button>
      </section>
    </div>
  )
}

export const WhereToDeliver = withErrorBoundary(WhereToDeliverComponent, {
  id: 'user.address_book.step.where_to_deliver',
  owner: Teams.WEB,
})
